<template>
    <div class="container">
        <div class="row">
            <Menu class="col-lg-3"></Menu>
            <div class="col-lg-9">
                <b-card class="card">
                    <b-card-title>
                        <b-icon-arrow-left class="back-link" @click="onBackArrowClick"></b-icon-arrow-left>

                        <span v-if="$route.params.id">Редактирование новости</span>
                        <span v-else-if="!$route.params.id">Создание новости</span>
                    </b-card-title>
                    <b-card-sub-title v-if="$route.params.id">{{ pubDate }}</b-card-sub-title>
                    <b-card-body>
                        <b-overlay :show="showOverlay" rounded="sm">
                        <b-form-group
                                id="fieldset-1"
                                description=""
                                label="Название статьи"
                                label-for="input-title"
                                :invalid-feedback="title.errorMessage"
                                :state="title.state"
                        >
                            <b-form-input id="input-title" v-model="title.content" :state="title.state" size="sm" trim></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label="Изображение для статьи"
                                label-for="input-title"
                                :state="file.state"
                                :invalid-feedback="file.errorMessage"
                        >
                            <b-form-file
                                    v-model="file.formFile"
                                    placeholder="Выберите или перетащите изображение для статьи..."
                                    drop-placeholder="Перетащите изображение сюда..."
                                    size="sm"
                                    class="upload-file"
                                    @input="onFileChanged"
                                    :state="file.state"
                            ></b-form-file>
                            <div v-if="file.showPreview">
                                <p>Предпросмотр:</p>
                                <b-img :src="file.fileLink" thumbnail fluid height="200px" width="200px" alt="Preview"></b-img>
                            </div>
                        </b-form-group>

                        <b-form-group
                                label="Текст статьи"
                                label-for="editor"
                                :state="editor.state"
                                :invalid-feedback="editor.errorMessage"
                        >
                            <Editor
                                    ref="editor"
                                    id="editor"
                                    :initialValue="editor.initialText"
                                    :options="editor.options"
                                    height="400px"
                                    initialEditType="wysiwyg"
                                    previewStyle="vertical"
                                    class="editor"
                            ></Editor>
                        </b-form-group>

                        <b-button variant="outline-primary" @click="onPublishClick" block>Опубликовать</b-button>
                        </b-overlay>
                    </b-card-body>
                </b-card>

                <b-modal ref="err-modal" size="sm" hide-footer>
                    <div class="d-block text-center">
                        Ошибка сервера!
                    </div>
                    <b-button class="mt-3" variant="danger" block @click="closeModal">ОК</b-button>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from "../../common/Menu";
import { Editor } from "@toast-ui/vue-editor";
import moment from 'moment';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';

export default {
    name: "NewsEditor",
    components: { Menu, Editor },
    data: () => ({
        title: {
            content: null,
            errorMessage: 'Максимальная длина сообщения 255 символов',
            state: null, // null валидно, false не валидно
        },
        pubDate: null,
        file: {
            formFile: null,
            fileLink: null,
            showPreview: false,
            imageId: null,
            originalImageId: null,
            imageHistory: [],
            changed: false,
            state: null,
            errorMessage: '',
        },
        editor: {
            state: null,
            errorMessage: 'Новость должна содержать статью!',
            initialText: '',
            options: {
                hideModeSwitch: true,
                toolbarItems: [
                    'heading',
                    'bold',
                    'italic',
                    'strike',
                    'divider',
                    'hr',
                    'quote',
                    'divider',
                    'ul',
                    'ol',
                    'indent',
                    'outdent',
                    'divider',
                    'table',
                    'link',
                    'divider',
                    'code',
                    'codeblock'
                ]
            }
        },
        showOverlay: true,
        errors: {
            emptyArticle: 'Новость должна содержать статью!',
            maxLengthArticle: 'Статья не может быть длиной больше 30 000 символов!'
        }
    }),
    created() {
        if (this.$route.params.id) {
            this.fetchArticle();
        } else {
            this.showOverlay = false;
        }
    },
    methods: {
        fetchArticle() {
                this.$http.get(`${process.env.VUE_APP_API_HOST}/news/${this.$route.params.id}`)
                        .then((result) => {
                            this.title.content = result.data.data.title;
                            this.pubDate = moment(result.data.data.pubDate).format('LL  HH:mm');
                            this.$refs.editor.invoke('setMarkdown', result.data.data.content);
                            if (result.data.data.photo) {
                                this.file.showPreview = true;
                                this.file.fileLink = result.data.data.photo.url;
                                this.file.imageId = result.data.data.photo.id;
                                this.file.originalImageId = result.data.data.photo.id;
                            }
                            this.showOverlay = false;
                        })
                        .catch(() => {
                            this.$refs['err-modal'].show();
                        });
        },
        async sendArticle() {
            await this.$http.put(`${process.env.VUE_APP_API_HOST}/news`, {
                id: this.$route.params.id ?? undefined,
                title: this.title.content,
                content: this.$refs.editor.invoke('getMarkdown').trim().replace(/<[^>]*>?/gm, ''),
                photoId: this.file.imageId ?? undefined,
                photoForDelete: this.file.imageHistory,
            }, {
                headers: {
                    Authorization: `JWT ${localStorage.getItem('jwt')}`
                }
            })
        },
        validateArticle() {
            let result = true;

            this.title.state = null;
            if (!this.title.content?.length) {
                this.title.errorMessage = 'Это поле обязательно!';
                this.title.state = false;
                result = false;
            } else if (this.title.content?.length > 27) {
                this.title.errorMessage = 'Максимальная длина сообщения 27 символов!';
                this.title.state = false;
                result = false;
            }

            if (this.file.state === false) {
                result = false;
            }

            if (!this.$refs.editor.invoke('getMarkdown').trim().length) {
                this.editor.errorMessage = this.errors.emptyArticle;
                this.editor.state = false;
                result = false;
            }

            if (this.$refs.editor.invoke('getMarkdown').trim().length > 30000) {
                this.editor.errorMessage = this.errors.maxLengthArticle;
                this.editor.state = false;
                result = false;
            }

            return result;
        },
        async onPublishClick() {
            if (!this.validateArticle()) {
                return;
            }

            this.file.imageHistory.pop();
            if (this.file.originalImageId && this.file.changed) {
                this.file.imageHistory.push(this.file.originalImageId);
            }

            try {
                await this.sendArticle();
                this.$router.push({ name: 'home' });
                return;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.refreshAuth();
                    } else {
                        this.$refs['err-modal'].show();
                        return;
                    }
                }
            }

            try {
                await this.sendArticle();
                this.$router.push({ name: 'home' });
            } catch (error) {
                // Show connection error
                this.$refs['err-modal'].show();
            }
        },
        closeModal() {
            this.$refs['err-modal'].hide();
        },
        async sendPhoto(formData) {
            await this.$http.put(`${process.env.VUE_APP_API_HOST}/news/photo`, formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Authorization': `JWT ${localStorage.getItem('jwt')}`
                }
            })
                    .then((result) => {
                        this.file.imageId = result.data.data.id;
                        this.file.fileLink = `${process.env.VUE_APP_BASE_HOST}/storage/${result.data.data.filename}`
                        this.file.showPreview = true;
                        if (+this.file.imageId !== +this.file.originalImageId) {
                            this.file.imageHistory.push(this.file.imageId);
                        }
                    });
        },
        async makeDeletePhotoQuery() {
            await this.$http.post(`${process.env.VUE_APP_API_HOST}/news/photo/delete`, this.file.imageHistory,{
                headers: {
                    'Authorization': `JWT ${localStorage.getItem('jwt')}`
                }
            })
        },
        async deletePhoto() {
            try {
                await this.makeDeletePhotoQuery();
                return true;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.refreshAuth();
                    } else {
                        this.$refs['err-modal'].show();
                        return false;
                    }
                }
            }

            try {
                await this.makeDeletePhotoQuery();
            } catch (error) {
                // Show connection error
                this.$refs['err-modal'].show();
                return false
            }
            return true;
        },
        isFileImage(file) {return /image\/.*/.test(file.type)},
        validateFile(file) {
            if (file.size > 26214400) {
                this.file.errorMessage = 'Максимальный размер изображения 25 Мб!';
                return false;
            }
            if (!this.isFileImage(file)) {
                this.file.errorMessage = 'Файл должен быть изображением!';
                return false;
            }
            return true;
        },
        async onFileChanged(file) {
            this.file.state = null;
            if (!this.validateFile(file)) {
                this.file.state = false;
                this.file.showPreview = false;
                return;
            }

            this.file.changed = true;

            if (!file) {
                this.file.showPreview = false;
                return;
            }

            const fd = new FormData();
            fd.append('photo', this.file.formFile);

            try {
                await this.sendPhoto(fd);
                return;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.refreshAuth();
                    } else {
                        this.$refs['err-modal'].show();
                        return;
                    }
                }
            }

            try {
                await this.sendPhoto(fd);
            } catch (error) {
                // Show connection error
                this.$refs['err-modal'].show();
            }
        },
        async onBackArrowClick() {
            await this.deletePhoto();
            await this.$router.push({ name: 'news' });
        },
    }
}
</script>

<style scoped>
    .editor {
        margin-bottom: 10px;
    }

    .back-link {
        color: black;
        cursor: pointer;
        font-size: 25px;
        padding: 3px;
        margin: 1px 10px 1px 1px;
        border-radius: 50%;
    }

    .back-link:hover {
        color: #007BFF;
        transition-duration: .5s;
    }

    .upload-file {
        margin-bottom: 10px;
    }
</style>